export default __webpack_public_path__ + "static/media/water-quality-company.ce4bc0a5.svg";